import { render, staticRenderFns } from "./CarClass.vue?vue&type=template&id=06faf06e&scoped=true&"
import script from "./CarClass.vue?vue&type=script&lang=js&"
export * from "./CarClass.vue?vue&type=script&lang=js&"
import style0 from "./CarClass.vue?vue&type=style&index=0&id=06faf06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faf06e",
  null
  
)

export default component.exports